import { forwardRef, useEffect, useRef } from "react";
import "../index.css";

const Canvas = forwardRef(function Canvas(props, forwardedRef) {
  const { draw, ...rest } = props;
  const internalRef = useRef(null);

  const canvasRef = forwardedRef ?? internalRef;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext("2d");
    draw(context);
  }, [canvasRef, draw]);

  return <canvas ref={canvasRef} {...rest} />;
});

export default Canvas;
